import { FileDown, ShieldCheck, BadgeCheck, ArrowRight } from "lucide-react";
import { Container, Reveal, SectionHead } from "./Primitives";
import { DownloadDialog } from "./DownloadDialog";

const ITEMS = [
  { resource: "brochure", icon: FileDown, title: "Company brochure", meta: "PDF · 6 pages · 0.7 MB", body: "Company overview, closure and preform range, full grammage table, quality and contact details.", cta: "Download brochure" },
  { resource: "iso-9001-certificate", icon: ShieldCheck, title: "ISO 9001:2015 certificate", meta: "PDF · Issued by DNV", body: "Quality management system certified to ISO 9001:2015 by DNV Business Assurance.", cta: "Download certificate" },
  { resource: "fssc-22000-certificate", icon: BadgeCheck, title: "FSSC 22000 certificate", meta: "PDF · Issued by DNV", body: "Food safety management system certified to FSSC 22000 by DNV Business Assurance.", cta: "Download certificate" },
];

export const DownloadCard = ({ item, i }) => (
  <Reveal delay={i * 0.06}>
    <div data-testid={`download-card-${item.resource}`} className="lift flex h-full flex-col border border-slate-200 bg-white p-8">
      <div className="flex items-start justify-between">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-navy text-white"><item.icon className="h-6 w-6" strokeWidth={1.6} /></div>
        <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{item.meta}</span>
      </div>
      <h3 className="font-display mt-6 text-xl font-semibold text-ink">{item.title}</h3>
      <p className="mt-3 flex-1 text-[15px] leading-relaxed text-slate-600">{item.body}</p>
      <DownloadDialog resource={item.resource}>
        <button data-testid={`download-btn-${item.resource}`} className="group mt-7 inline-flex items-center gap-2 self-start text-sm font-semibold text-navy hover:text-brand transition-colors">
          {item.cta}<ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </DownloadDialog>
    </div>
  </Reveal>
);

export const DownloadsSection = ({ className = "bg-mist" }) => (
  <section id="downloads" data-testid="downloads-section" className={`py-24 lg:py-32 scroll-mt-24 ${className}`}>
    <Container>
      <SectionHead eyebrow="Downloads" title="Certificates & company brochure" lead="Everything your procurement and quality teams need to qualify MU Plast as a supplier." />
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {ITEMS.map((it, i) => <DownloadCard key={it.resource} item={it} i={i} />)}
      </div>
    </Container>
  </section>
);
